import { useContext, useState } from "react";
import Input from "../atoms/Input";
import { MultiContext } from "../../Context";
import Button from "../atoms/Button";

export default function NewRepo({ className = "" }) {
  const multiCtx = useContext(MultiContext);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const onChangeName = (e) => setName(e.target.value);
  const onChangeDescription = (e) => setDescription(e.target.value);

  return (
    <form
      onSubmit={(e) => {
        multiCtx.addRepo(e, name);
        setName("");
      }}>
      <div className={className + " input-group input-group-sm mb-3"}>
        <Input value={name} onChange={onChangeName} placeholder="New Repo" />
        <Button
          active={multiCtx.loading}
          onClick={() =>
            multiCtx.generateName((data) => {
              setName(data.name);
              setDescription(`# ${data.name}\n---\n`);
            })
          }
          text="Generate Name"
          icon="shuffle"
        />
      </div>
      <textarea
        onChange={onChangeDescription}
        value={description}
        rows={9}
        className="form-control form-control-sm"
        placeholder="Description"></textarea>
      <div className="divider my-2"></div>
      <Button
        text="Init Repo"
        type_="submit"
        className="w-100"
        icon="plus-lg"
      />
    </form>
  );
}
